// ==================================================
// Extrae un parametro de la current url
// ==================================================   
const getURLParameter = (n, url) => {
    const path = url || location.search;
    return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(path) || [null, ''])[1].replace(/\+/g, '%20')) || null;
};

// handling para rutas de preview
const previewRoutePrefix = '/preview/';
const previewRouteSkipParamsOffset = 2;

const getURLIsPreview = () => {
    return window.location.pathname.startsWith(previewRoutePrefix);
};

const getURLPath = (n) => {
    const isPreview = getURLIsPreview();
    const index = (n || 0) + (isPreview ? previewRouteSkipParamsOffset : 0);
    
    var pathArray = window.location.pathname.split('/').filter(e => e);
    return pathArray[index];
};

const getURLQueryString = () => {
    return window.location.search.replace("?", "");
};

const testMatchURL = (url) => {
    let regexExp = new RegExp(document.location.host + "\/[a-zA-z]+(\/[A-Z]\/[0-9]\/[0-9])?");
    return regexExp.test(url);
};

const isLoginReferrer = () => {
    if (!document.referrer || document.referrer == '') return false
    const regExp = new RegExp('/ingresar.lanacion.com.ar')
    return regExp.test(document.referrer)
}

module.exports = {
    getURLParameter,
    getURLPath,
    getURLQueryString,
    testMatchURL,
    isLoginReferrer
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/urlHelpers.js